"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FontStyle = void 0;
var FontStyle;
(function (FontStyle) {
    FontStyle["Normal"] = "u-font-normal";
    FontStyle["NormalImportant"] = "u-font-normal!";
    FontStyle["Italic"] = "u-font-italic";
    FontStyle["ItalicImportant"] = "u-font-italic!";
    FontStyle["Oblique"] = "u-font-oblique";
    FontStyle["ObliqueImportant"] = "u-font-oblique!";
})(FontStyle = exports.FontStyle || (exports.FontStyle = {}));
//# sourceMappingURL=FontStyle.js.map